import React from 'react';
import { useTranslation } from 'react-i18next';

import { OfpList } from './OfpList/OfpList';
import { Panel } from '../Panel/Panel';
import { PreFlightPanel } from './PreFlightPanel';
import { StartWorkTime } from './StartWorkTime/StartWorkTime';

import './StartInfoPage.scss';

export const StartInfoPage = () => {
    const { t: translate } = useTranslation();

    return (
        <div className="start-info">
            <Panel title={translate('labels.ofpList')} className="start-info__ofp-list">
                <OfpList />
            </Panel>
            <div className="start-info__panels">
                <StartWorkTime />
            </div>
            <Panel title={translate('labels.preFlightBriefing')} className="start-info__briefing">
                <PreFlightPanel />
            </Panel>
        </div>
    );
};
